import React from "react";
import Navb from "../../../../components/navbar/Navb";
import Footer from "../../../../components/footer/Footer";
import RecipiePage from "../../../../components/recipiePage/RecipiePage";
import Recpiesimg1 from "./recpiesimg1.png";
import Recpiesimg2 from "./recpiesimg2.png";
import Recpiesimg3 from "../../img8.png";
import Recpiesimg4 from "../../img10.png";
import Recpiesimg5 from "../../img13.png";
import Img1 from "./img1.png";
// import Timer from "../timer.png";
// import "../recipe.css";
const Daliakhichadi = () => {
  return (
    <>
    <RecipiePage
        Recpiesimg1={Recpiesimg1}
        Recpiesimg2={Recpiesimg2}
        Recpiesimg3={Recpiesimg3}
        Recpiesimg4={Recpiesimg4}
        Recpiesimg5={Recpiesimg5}
        Img1={Img1}
        Name="Dalia Khichadi"
        Ul1={
          <ul>
            <li>
              <span className="Bold">Nandi Maida (cracked wheat)</span>
            </li>
            <li>mixed vegetables</li>
            <li>tomato  chopped</li>
            <li>mustard seeds </li>
            <li>Ginger Garlic Paste </li>
          </ul>
        }
        Ul2={
          <ul className="noDecoration">
            <li>500g</li>
            <li>2 tablespoons </li>
            <li> 2 large</li>
            <li>2 cups</li>
            <li>1 tablespoon</li>
          </ul>
        }
        Ul3={
          <ul>
            <li>Red Chilli Powder</li>
            <li>Turmeric Powder</li>
            <li>Salt</li>
            <li>Fresh Coriander leaves</li>
          </ul>
        }
        Ul4={
          <ul className="noDecoration">
            <li>1 tablespoon</li>
            <li>1/2 tablespoon </li>
            <li>to taste</li>
            <li>for garnish</li>
          </ul>
        }
        Ol1={
          <ol>
            <li>Rinse the dalia under running water. Set aside.</li>
            <li>
              Heat ghee or oil in a pressure cooker. Add cumin seeds and mustard
              seeds. Let them splutter.
            </li>
            <li>Add chopped onions and sauté until they turn translucent.</li>
            <li>Add mixed vegetables and sauté for a few minutes.</li>
            <li>Add chopped tomatoes and cook until they become soft.</li>
            <li>
              Add turmeric powder, red chili powder, garam masala, and salt. Mix
              well.
            </li>
            <li>
              Add rinsed dalia to the vegetable mixture. Sauté for a couple of
              minutes.
            </li>
            <li>
              Pour in water (usually 2.5 to 3 cups for 1 cup of dalia), stir
              well, and close the pressure cooker.
            </li>
            <li>
              Cook for 3-4 whistles or until the dalia is cooked and has a
              porridge-like consistency.
            </li>
            <li>Garnish with fresh coriander leaves and serve hot.</li>
          </ol>
        }
        Item1="Sooji and Vegitable Cheela"
        Item2="Dalia Salad"
        Item3="Nandi Sabji Masala"
        Link1="sojivegcheela"
        Link2="daliasalad"
        Link3="nandisabjimasala"
      />
      {/* <Navb />
      <div className="singleRecipeTop">Dalia Khichadi</div>
      <img className="singleRecipeTopimg" src={Recpiesimg1} alt="Recpiesimg1" />
      <div className="singleRecipeBot">
       
        <div className="singleRecipeBotLeftItems">
          <div className="singleRecipeBotLeftItemTitle">INGREDIENTS</div>
          <hr />
          <div className="singleRecipeBotLeftItem">
            <ol>
              <li>
                1 cup <span className="Bold">Nandi dalia (cracked wheat)</span>{" "}
              </li>
              <li>
                1/2 cup mixed vegetables (carrots, peas, potatoes, beans),
                chopped
              </li>
              <li>1 onion, finely chopped</li>
              <li>1 tomato, chopped</li>
              <li>1/2 teaspoon cumin seeds</li>
              <li>1/2 teaspoon mustard seeds</li>
              <li>1/2 teaspoon turmeric powder</li>
              <li>1/2 teaspoon red chili powder</li>
              <li>1/2 teaspoon garam masala</li>
              <li>Salt to taste</li>
              <li>2 tablespoons ghee or oil</li>
              <li>Fresh coriander leaves for garnishinga (optional)</li>
              <li>Oil or ghee for cooking</li>
            </ol>
          </div>
          <hr />
          <div className="flexitemrecipe">
            <img src={Recpiesimg2} alt="Recpiesimg2" />
            Nandi Dalia
          </div>
        </div>
        <div className="singleRecipeBotRight">
          <div className="singleRecipeBotRightTop">Instructions</div>
          <ol>
            <li>Rinse the dalia under running water. Set aside.</li>
            <li>
              Heat ghee or oil in a pressure cooker. Add cumin seeds and mustard
              seeds. Let them splutter.
            </li>
            <li>Add chopped onions and sauté until they turn translucent.</li>
            <li>Add mixed vegetables and sauté for a few minutes.</li>
            <li>Add chopped tomatoes and cook until they become soft.</li>
            <li>
              Add turmeric powder, red chili powder, garam masala, and salt. Mix
              well.
            </li>
            <li>
              Add rinsed dalia to the vegetable mixture. Sauté for a couple of
              minutes.
            </li>
            <li>
              Pour in water (usually 2.5 to 3 cups for 1 cup of dalia), stir
              well, and close the pressure cooker.
            </li>
            <li>
              Cook for 3-4 whistles or until the dalia is cooked and has a
              porridge-like consistency.
            </li>
            <li>Garnish with fresh coriander leaves and serve hot.</li>
          </ol>
        </div>
      </div>
      <div className="singleRecipeEnd">
        <div className="singleRecipeEndTitle">You Might Also Like</div>
        <div className="singleRecipeEndItems">
          <div className="singleRecipeEndItem">
            <div className="singleRecipeEndItemTop">
              <a href="/recipes/daliasalad">
                <img src={Recpiesimg3} alt="Recpiesimg3" />
                <div className="singleRecipeEndItemTitle">Dalia Salad</div>
              </a>
            </div>
            <div>
              <img src={Timer} alt="Timer" />
              <span>Ready in 15 mins</span>
            </div>
          </div>
          <div className="singleRecipeEndItem">
            <div className="singleRecipeEndItemTop">
              <a href="/recipes/nandimeatmasalacurry">
                <img src={Recpiesimg4} alt="Recpiesimg4" />
                <div className="singleRecipeEndItemTitle">
                  Nandi Meat Masala Curry
                </div>
              </a>
            </div>
            <div>
              <img src={Timer} alt="Timer" />
              <span>Ready in 50 mins</span>
            </div>
          </div>
          <div className="singleRecipeEndItem">
            <div className="singleRecipeEndItemTop">
              <a href="/recipes/wholeattacookies">
                <img src={Recpiesimg5} alt="Recpiesimg5" />
                <div className="singleRecipeEndItemTitle">
                  Whole Atta Cookies
                </div>
              </a>
            </div>
            <div>
              <img src={Timer} alt="Timer" />
              <span>Ready in 50 mins</span>
            </div>
          </div>
        </div>
      </div>
      <Footer /> */}
    </>
  );
};

export default Daliakhichadi;
